
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 21 21","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.5 1.925c2.8 0 3.15 0 4.287.088 2.888.087 4.2 1.487 4.288 4.287.088 1.138.088 1.4.088 4.2 0 2.8 0 3.15-.088 4.2-.087 2.8-1.488 4.2-4.287 4.288-1.138.087-1.4.087-4.288.087-2.8 0-3.15 0-4.2-.087C3.413 18.9 2.1 17.5 2.013 14.7c-.088-1.137-.088-1.4-.088-4.2 0-2.8 0-3.15.088-4.2C2.1 3.5 3.5 2.1 6.3 2.013c1.05-.088 1.4-.088 4.2-.088zM10.5 0C7.612 0 7.263 0 6.213.087 2.363.263.263 2.363.088 6.213 0 7.263 0 7.613 0 10.5c0 2.887 0 3.238.087 4.287.176 3.85 2.276 5.95 6.125 6.126C7.263 21 7.613 21 10.5 21c2.887 0 3.238 0 4.287-.087 3.85-.175 5.95-2.276 6.126-6.126.087-1.05.087-1.4.087-4.287 0-2.888 0-3.237-.087-4.287-.175-3.85-2.276-5.95-6.126-6.125C13.737 0 13.387 0 10.5 0zm0 5.075c-2.975 0-5.425 2.45-5.425 5.425 0 2.975 2.45 5.425 5.425 5.425 2.975 0 5.425-2.45 5.425-5.425 0-2.975-2.45-5.425-5.425-5.425zm0 8.925A3.51 3.51 0 017 10.5 3.51 3.51 0 0110.5 7a3.51 3.51 0 013.5 3.5 3.51 3.51 0 01-3.5 3.5zm5.6-10.325c-.7 0-1.225.525-1.225 1.225 0 .7.525 1.225 1.225 1.225.7 0 1.225-.525 1.225-1.225 0-.7-.525-1.225-1.225-1.225z"}})])
          )
        }
      }
    